import { useState } from "react";
import { installTabs } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function InstallGuide() {
  const [activeTab, setActiveTab] = useState(installTabs[0].key);
  const active = installTabs.find((tab) => tab.key === activeTab) ?? installTabs[0];

  return (
    <section id="install" className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="下载安装"
          title="从获取安装包到装好应用，一步步来"
          description="安卓与苹果两条路径略有不同，先切换到你手上的设备类型，再照着对应步骤操作，安装前的系统和权限提醒也一并列在下方。"
        />

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-[1.15fr_0.85fr] md:mt-12 md:gap-8">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
            <div className="inline-flex rounded-full bg-background-100 p-1">
              {installTabs.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setActiveTab(tab.key)}
                  className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                    activeTab === tab.key
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-foreground-950"
                  }`}
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className={`${tab.icon} text-base`}></i>
                  </span>
                  <span className="whitespace-nowrap">{tab.label}</span>
                </button>
              ))}
            </div>

            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              {active.intro}
            </p>

            <ol className="mt-6 space-y-4">
              {active.steps.map((step, index) => (
                <li key={step} className="flex gap-4">
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-primary-500 text-xs font-bold text-background-50">
                    {index + 1}
                  </span>
                  <span className="pt-0.5 text-sm leading-relaxed text-foreground-700">{step}</span>
                </li>
              ))}
            </ol>
          </div>

          <aside className="flex flex-col gap-4">
            <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-primary-800 md:text-lg">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-lightbulb-flash-line text-lg"></i>
                </span>
                安装前请留意
              </h3>
              <ul className="mt-4 space-y-3">
                {active.notes.map((note) => (
                  <li key={note} className="flex gap-3 text-sm leading-relaxed text-foreground-700">
                    <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-primary-400"></span>
                    {note}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-accent-50 p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-accent-800 md:text-lg">
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className="ri-question-answer-line text-lg"></i>
                </span>
                装好之后先做什么
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                打开应用后建议先授权存储权限，再登录或浏览剧集。权限给到位，后面缓存视频时就不用反复弹窗确认，缓存到手机也会更顺畅。
              </p>
              <a
                href="#cache"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-accent-800 hover:text-accent-900"
              >
                继续看缓存视频教程
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}